(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features"] && !Shopify.designMode) return;
  try {
    
     var swiper = new Swiper(".mySwiper", {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            }
        });

  
        var swiper = new Swiper(".mySwiper1", {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            }
        })

  } catch(e) { console.error(e); }
})();
})();
